import { useQuickMenu } from "@/hooks/useQuickMenu";
import { useQuickMenuFold } from "@/hooks/useQuickMenuFold";
import { useQuickMenuSettings } from "@/hooks/useQuickMenuSettings";

import { QuickMenu } from "./QuickMenu";
import { QuickMenuSettings } from "./QuickMenuSettings";

/**
 * 로그인 후 화면 공용 자주찾는 메뉴 띠. `Layout` 이 헤더 바로 아래에 두므로 어느
 * 화면에서든 같은 자리에서 열고 접을 수 있다.
 *
 * 칸·접힘·설정 상태는 각각 훅(`useQuickMenu`, `useQuickMenuFold`,
 * `useQuickMenuSettings`)이 갖고, `QuickMenu` 와 `QuickMenuSettings` 는 그리기만
 * 한다 — 이 컴포넌트는 그 둘을 훅에 이어 줄 뿐이다. 띠는 페이지 흐름 안에 있어 문서와
 * 함께 스크롤되고, 고정되는 것은 헤더뿐이다.
 */
export default function AppQuickMenu() {
  const items = useQuickMenu();
  const { isOpen, toggle } = useQuickMenuFold();
  const { openDialog, dialog } = useQuickMenuSettings();

  return (
    <>
      <QuickMenu
        items={items}
        onOpenSettings={openDialog}
        isOpen={isOpen}
        onToggle={toggle}
      />
      <QuickMenuSettings {...dialog} />
    </>
  );
}
